<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="keyword">
					<el-input v-model="listQuery.name" placeholder="请输入类型名称" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'CardType.create'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'CardType.delete'" class="action-item" icon="el-icon-delete"
					@click="BatchDelete">删除</el-button>

			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<!--列开始-->
			<el-table-column type="selection"></el-table-column>
			<el-table-column align="center" prop="name" label="类型名称"> </el-table-column>
			<el-table-column align="center" prop="space_discount" label="订场费用折扣 "> </el-table-column>
			<el-table-column align="center" prop="coach_discount" label="预约教练费用折扣 "> </el-table-column>
			<el-table-column align="center" prop="combo_discount" label="购买教练课程套餐费用折扣 "> </el-table-column>
			<el-table-column align="center" prop="weight" label="优先排队权重 "> </el-table-column>
			<!-- <el-table-column align="center" prop="order_no" label="排序"> </el-table-column> -->

			<el-table-column align="center" prop="" label="操作" width="200" class-name="action">
				<template slot-scope="scopes">
					<el-button v-auth="'CardType.update'" plain icon="el-icon-edit" type="primary" size="mini"
						@click="HandleUpdate(scopes.row)">编辑</el-button>
					<el-button v-auth="'CardType.delete'" plain icon="el-icon-delete" type="danger" size="mini"
						@click="RowDelete(scopes.row)">删除</el-button>

				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />
		<!--弹窗编辑/新增窗体-->
		<el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
			<el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="190px"
				style="width: 100%;">
				<el-form-item label="类型名称" prop="name">
					<el-input v-model="temp.name" style="width:80%;" placeholder="请输入类型名称" />
				</el-form-item>
				<el-form-item label="订场费用折扣" prop="space_discount">
					<el-input-number v-model="temp.space_discount" :min="0" :max="10" :step="0.1" :precision="1" />
					<el-tooltip content="0~10有1位小数的数字，0则是不收费，10则是不打折" placement="top-start" style="margin-left:10px;">
						<i class="el-icon-question" />
					</el-tooltip>
				</el-form-item>
				<el-form-item label="预约教练费用折扣" prop="coach_discount">
					<el-input-number v-model="temp.coach_discount" :min="0" :max="10" :step="0.1" :precision="1" />
					<el-tooltip content="0~10有1位小数的数字，0则是不收费，10则是不打折" placement="top-start" style="margin-left:10px;">
						<i class="el-icon-question" />
					</el-tooltip>
				</el-form-item>
				<el-form-item label="购买教练课程套餐费用折扣" prop="combo_discount">
					<el-input-number v-model="temp.combo_discount" :min="0" :max="10" :step="0.1" :precision="1" />
					<el-tooltip content="0~10有1位小数的数字，0则是不收费，10则是不打折" placement="top-start" style="margin-left:10px;">
						<i class="el-icon-question" />
					</el-tooltip>
				</el-form-item>
				<el-form-item label="优先排队权重" prop="weight">
					<el-input-number v-model="temp.weight" :min="0" :step="1" />
					<el-tooltip content="权重的数字越大越优先排队" placement="top-start" style="margin-left:10px;">
						<i class="el-icon-question" />
					</el-tooltip>
				</el-form-item>
				<!-- <el-form-item label="排序" prop="order_no">
          <el-input-number v-model="temp.order_no" :min="0" :step="1" />
          <el-tooltip content="排序的数字越小越靠前" placement="top-start" style="margin-left:10px;">
            <i class="el-icon-question" />
          </el-tooltip>
        </el-form-item> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="ConfirmData">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/card_type' // 和数据交互相关写在api 方便复用
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	import dict_data from '@/api/system/dict_data'

	export default {
		name: 'CardType',
		components: {
			Pagination
		},
		// 列绑定格式化器
		filters: {},
		mixins: [commonList],
		data() {
			return {
				// api接口方法
				api,
				// 校验
				rules: {
					name: [{
						required: true,
						message: '请输入类型名称',
						trigger: ['blur', 'change']
					}],
					space_discount: [{
						required: true,
						message: '请输入订场费用折扣',
						trigger: ['blur', 'change']
					}],
					coach_discount: [{
						required: true,
						message: '请输入预约教练费用折扣',
						trigger: ['blur', 'change']
					}],
					combo_discount: [{
						required: true,
						message: '请输入购买教练课程套餐费用折扣',
						trigger: 'blur'
					}]
				},
				temp: {},
				listQuery: {
					page: 1,
					limit: 10, // 页大小
					order: 'asc', // 默认排序方式,
					sort: 'id'
				},
				// 字典参数
				dictionary: []
				// 字典参数
			}
		},
		created() {
			this.loadData()
			dict_data.Drop({
				sort: 'sort',
				order: 'asc',
				isPaginator: false,
				dict_code: ''
			}).then(response => {
				this.dictionary = response.data
			})
		},
		methods: {
			resetTemp() {
				this.temp = {
					id: undefined,
					order_no: 99999,
					name: '',
					space_discount: 10,
					coach_discount: 10,
					combo_discount: 10,
					weight: 1

				}
			}

		}
	}
</script>